
  var _styles = {
  "phx-poi-lis--top-area-normal": {
    "width": "4.56rem",
    "height": "3.41333rem"
  },
  "phx-poi-lis--card-container-normal": {
    "width": "4.56rem",
    "height": "6.92rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "phx-poi-lis--top-area-small": {
    "width": "4.18667rem",
    "height": "3.13333rem"
  },
  "phx-poi-lis--card-container-small": {
    "width": "4.18667rem",
    "height": "6.53333rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "phx-poi-lis--top-area-big": {
    "width": "9.36rem",
    "height": "5.25333rem"
  },
  "phx-poi-lis--card-container-big": {
    "width": "9.36rem",
    "height": "8.86667rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "phx-poi-lis--book-info-container": {
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "0.10667rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "phx-poi-lis--book-info": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "marginLeft": "0.08rem"
  },
  "phx-poi-lis--head-icon": {
    "position": "absolute",
    "height": "0.42667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "top": 0,
    "left": 0,
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-big": {
    "position": "absolute",
    "height": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "top": 0,
    "left": 0,
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-image-container": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.38667rem",
    "height": "0.42667rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-image": {
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem"
  },
  "phx-poi-lis--head-icon-text-big": {
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem"
  },
  "phx-poi-lis--poi-name": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "phx-poi-lis--poi-name-big": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.48rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem",
    "marginLeft": "0.10667rem"
  },
  "phx-poi-lis--score-rating-user-review-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--score": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(6,68,155)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "phx-poi-lis--score-big": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(6,68,155)",
    "whiteSpace": "nowrap",
    "marginRight": "0.08rem",
    "marginLeft": "0.10667rem"
  },
  "phx-poi-lis--rating": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "phx-poi-lis--rating-big": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(0,64,153)",
    "whiteSpace": "nowrap",
    "marginRight": "0.16rem"
  },
  "phx-poi-lis--user-review": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "whiteSpace": "nowrap",
    "color": "rgb(0,64,153)"
  },
  "phx-poi-lis--user-review-big": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "whiteSpace": "nowrap",
    "color": "rgb(0,64,153)"
  },
  "phx-poi-lis--discount-content": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "left"
  },
  "phx-poi-lis--sales-count-content": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "phx-poi-lis--average-price-content": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "phx-poi-lis--sales-count-container": {
    "background": "#fff1ec",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "marginRight": "0.08rem",
    "height": "0.42667rem",
    "borderRadius": "0.08rem",
    "paddingLeft": "0.08rem",
    "paddingRight": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--average-price-container": {
    "background": "#fff1ec",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "marginRight": "0.08rem",
    "height": "0.42667rem",
    "borderRadius": "0.08rem",
    "paddingLeft": "0.08rem",
    "paddingRight": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--discount-container": {
    "background": "#ff4700",
    "height": "0.42667rem",
    "borderRadius": "0.08rem",
    "paddingLeft": "0.08rem",
    "paddingRight": "0.08rem",
    "marginRight": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--small-tag-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "marginTop": "0.13333rem"
  },
  "phx-poi-lis--small-tag-container-big": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "marginTop": "0.16rem",
    "marginLeft": "0.10667rem"
  },
  "phx-poi-lis--prev": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "phx-poi-lis--prev-big": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC",
    "fontSize": "0.48rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem",
    "marginBottom": "0.13333rem"
  },
  "phx-poi-lis--price": {
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem"
  },
  "phx-poi-lis--price-big": {
    "fontSize": "0.8rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.96rem"
  },
  "phx-poi-lis--behind": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0
  },
  "phx-poi-lis--behind-big": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.50667rem",
    "marginBottom": "0.08rem",
    "marginLeft": "0.05333rem"
  },
  "phx-poi-lis--buy-button-text": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "phx-poi-lis--buy-button-text-big": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.4rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.48rem"
  },
  "phx-poi-lis--sell-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "phx-poi-lis--origin-price": {
    "textDecoration": "line-through",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.34667rem"
  },
  "phx-poi-lis--origin-price-big": {
    "textDecoration": "line-through",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(153,153,153)",
    "WebkitTextDecorationColor": "#999",
    "textDecorationColor": "#999",
    "letterSpacing": 0,
    "lineHeight": "0.45333rem",
    "marginBottom": "0.08rem"
  },
  "phx-poi-lis--price-area": {
    "position": "relative"
  },
  "phx-poi-lis--price-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "phx-poi-lis--price-wrap-big": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "phx-poi-lis--buy-button-wrap": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgb(255,119,0)",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "30px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.32rem"
  },
  "phx-poi-lis--buy-button-wrap-big": {
    "position": "absolute",
    "right": 0,
    "bottom": "0.16rem",
    "backgroundColor": "rgb(255,119,0)",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "40px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.24rem",
    "paddingRight": "0.48rem",
    "paddingBottom": "0.22667rem",
    "paddingLeft": "0.48rem"
  },
  "phx-poi-lis--bottom-area": {
    "width": "100%",
    "height": "3.50667rem",
    "paddingTop": "0.14667rem",
    "paddingRight": "0.24rem",
    "paddingBottom": "0.32rem",
    "paddingLeft": "0.24rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "phx-poi-lis--bottom-area-big": {
    "width": "100%",
    "height": "3.61333rem",
    "paddingTop": "0.30667rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.28rem",
    "paddingLeft": "0.21333rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "phx-poi-lis--position-info": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFangSC-Regular",
    "color": "rgb(255,255,255)",
    "textDecoration": "none",
    "fontWeight": "500"
  },
  "phx-poi-lis--position-info-big": {
    "fontSize": "0.32rem",
    "fontFamily": "PingFangSC-Regular",
    "color": "rgb(255,255,255)",
    "textDecoration": "none",
    "fontWeight": "500"
  },
  "phx-poi-lis--position-info-wrapper": {
    "height": "0.72rem",
    "position": "absolute",
    "left": 0,
    "bottom": 0,
    "width": "100%"
  },
  "phx-poi-lis--position-info-bg": {
    "position": "absolute",
    "left": 0,
    "top": 0,
    "zIndex": 5,
    "width": "100%",
    "height": "100%",
    "opacity": 0.6
  },
  "phx-poi-lis--position-info-content": {
    "position": "absolute",
    "left": 0,
    "top": 0,
    "zIndex": 10,
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--position-info-icon": {
    "width": "0.21333rem",
    "height": "0.24rem",
    "marginLeft": "0.24rem",
    "marginRight": "0.08rem"
  },
  "phx-poi-lis--house-desc": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "lineHeight": "0.53333rem"
  },
  "phx-poi-lis--house-desc-big": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "lineHeight": "0.56rem",
    "marginLeft": "0.10667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-bold2', 'url("https://s0.meituan.net/bs/tempfs/file/dongxiaoxue/MTfin-bold2.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  